module.exports = __webpack_public_path__ + "media/images/or_key-a4de87805f93cf2a4aba73f8d8848a75.jpeg";